// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"697928e3","455":"de10428e","484":"57fee739","551":"ddea45a0","977":"0ef1b64b"}[chunkId] + ".chunk.js";
};